export default __webpack_public_path__ + "static/media/pocktvr.31bc6834.png";